<template>
	<page>
		<module>
			<div class="order-state flex-between-center">
				<!--				<h1>状态{{checkState}}：{{orderState}}</h1>-->
				<h1>{{orderState}}</h1>
				<p>{{orderStateWord}}</p>
			</div>

			<div class="order-node">
				<node-list :nodes="nodeList"></node-list>
			</div>

			<div class="order-detail">
				<c-table v-if="orderDetail" :data="productList" :paging="false" border>
					<c-table-column label="服务信息" width="300">
						<template #default="{data}">
							<product-info v-if="data.product_itemnumber" :image="data.product_img_url"
								:name="data.product_itemnumber + ' - '+data.product_name"></product-info>
							<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
						</template>
					</c-table-column>

					<c-table-column label="服务类型" width="100">
						<template v-slot="{data}">
							<span v-if="data.platfrom_sku_id!=0" style="color:blue">分销</span>
							<span v-else style="color:#999">自建</span>
						</template>
					</c-table-column>

					<!--					<c-table-column
						label="规格名"
						width="110"
					>
						<template v-slot="{data}">
							{{data.product_sku_spec}}
						</template>
					</c-table-column>

					<c-table-column
						label="服务SKU编码"
						width="120"
					>
						<template v-slot="{data}">
							{{data.product_sku_code?data.product_sku_code:'&#45;&#45;'}}
						</template>
					</c-table-column>-->

					<c-table-column label="成交单价">
						<template v-slot="{data}">
							<span v-if="orderDetail.order_state == 0 && !data.product_unit_price" style="color:brown;">
								待报价
							</span>
							<span v-else>
								￥{{parseFloat(data.product_unit_price).toFixed(2)}}
							</span>

							<font style="text-decoration: line-through;color:#999999;"
								v-if="orderDetail.order_state != 0 && data.product_unit_price!=data.original_product_price">
								<br />
								￥{{orderDetail.order_type==2?data.original_product_price:parseFloat(data.original_product_price).toFixed(2)}}
							</font>
						</template>
					</c-table-column>

					<c-table-column label="数量" width="80">
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>

					<c-table-column label="折扣率" width="85" v-if="orderDetail.order_type != 2">
						<template v-slot="{data}">
							<span v-if="orderDetail.order_state == 0 && (!data.product_unit_price || !data.original_product_money)"
								style="color:brown;">
								待报价
							</span>
							<span v-else-if="data.original_product_money == 0 || data.product_unit_price == 0">
								--
							</span>
							<span v-else>
								{{parseFloat(data.product_unit_price*data.product_count*100/data.original_product_money).toFixed(2)}}%
							</span>
						</template>
					</c-table-column>

					<c-table-column label="服务总额">
						<template v-slot="{data}">
							<span v-if="orderDetail.order_state == 0 && !data.product_money" style="color:brown;">
								待报价
							</span>
							<span v-else>
								￥{{parseFloat(data.product_money).toFixed(2)}}
							</span>
							<font style="text-decoration: line-through;color:#999999;"
								v-if="orderDetail.order_state != 0 && data.product_money!=data.original_product_money">
								<br />
								￥{{orderDetail.order_type==2?data.original_product_money:parseFloat(data.original_product_money).toFixed(2)}}
							</font>
						</template>
					</c-table-column>
					<!--                    <c-table-column
                            label="未发退款数"
                    >
                        <template v-slot="{data}">
                            {{data.total_refund_count}}
                        </template>
                    </c-table-column>

                    <c-table-column
                            label="已发退货数"
                    >
                        <template v-slot="{data}">
                            {{data.total_return_count}}
                        </template>
                    </c-table-column>
					
					<c-table-column
						label="重量小计(克)"
						width="100"
					>
						<template v-slot="{data}">
							{{data.product_weight?data.product_weight:'&#45;&#45;'}}
						</template>
					</c-table-column>
					
					<c-table-column
						label="已发货数"
					>
						<template v-slot="{data}">
							<span v-if="data.is_virtual == 0" >{{data.send_count}}</span>
							<span v-if="data.is_virtual == 1 && orderDetail.payment_state == 3" style="color:darkgreen">已发放电子券码</span>
							<span v-if="data.is_virtual == 1 && orderDetail.payment_state != 3" style="color:#999">支付后发放电子券码</span>
						</template>
					</c-table-column>-->
				</c-table>
				<div class="order-total flex-between-center" v-if="orderDetail.operation_mode == 2">
					<div>
						<!--服务总数 {{this.orderDetail.product_count}}，-->
						订单总额 ￥{{parseFloat(orderDetail.product_money).toFixed(2)}}
					</div>
					<div class="flex" style="gap: 20px;">
						<dd>{{orderDetail.payment_state == 1 ? '应付':'已付'}}金额：<span><b>￥{{paymentTotal}}</b></span></dd>
						<dd v-if="orderDetail.payment_state == 2 && orderDetail.order_state != 5 && orderDetail.order_state != 6">
							待付尾款：<b>￥{{(parseFloat(orderDetail.product_money) - paymentTotal).toFixed(2)}}</b></dd>
					</div>
				</div>

				<dl v-if="orderHistoryList && orderHistoryList.length > 0">
					<dt>服务记录</dt>
					<dd class="service-record">
						<ul>
							<li v-for="(item, i) in orderHistoryList" :key="i">
								<p class="service-date">{{item.create_date}}
									<span>
										【{{userTypeName[item.user_type]}}】
									</span>
									<span v-if="item.user_type == 1 || item.user_type == 2 || item.user_type == 3">
										{{item.nick_name||'-'}}({{item.user_manage_mobilephone}})
									</span>
									<span v-if="item.user_type == 4 || item.user_type == 99">
										{{item.user_realname||'-'}}
									</span>
								</p>
								<p class="service-remark">{{item.remark}}</p>

								<div v-if="item.material_file && item.material_file.length" class="service-file">
									<div class="service-file-item flex-center-cross" v-for="(file, j) in parseMaterialFile(item.material_file)" :key="j" @click="previewFile(file)">
										<i :class="getFileIconClass(file.file_type)"></i>
										<p class="ellipsis">{{ file.file_name }}</p>
									</div>
								</div>
							</li>
						</ul>
					</dd>
				</dl>

				<dt v-if="orderRewardList && orderRewardList.length > 0">费用明细</dt>
				<c-table v-if="orderRewardList && orderRewardList.length>0" :data="orderRewardList" style="width:480px;" :paging="false"
					border>
					<!-- <c-table-column
						label="流水号"
						name="record_number"
						width="120"
					></c-table-column> -->

					<c-table-column label="费用类型 " name="reward_type" width="100">
						<template v-slot="row">
							{{rewardTypeName[row.data.reward_type]}}
						</template>
					</c-table-column>

					<c-table-column label="占比" name="record_ratio" width="90">
						<template v-slot="row">
							{{parseFloat((parseFloat(row.data.record_ratio)*100).toFixed(2))}}%
						</template>
					</c-table-column>

					<!-- <c-table-column
						label="预计结算金额"
						name="estimated_record_money"
						width="100"
					>
						<template v-slot="row">
						    <span style="color:blue;">¥{{parseFloat(parseFloat(row.data.estimated_record_money).toFixed(2))}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="预计最终结算金额"
						name="original_record_money"
						width="130"
					>
						<template v-slot="row">
							<span style="color:gray;">¥{{parseFloat(parseFloat(row.data.original_record_money).toFixed(2))}}</span>
						</template>
					</c-table-column> -->

					<!-- <c-table-column
						label="结算状态"
						name="state"
						width="75"
					>
						<template v-slot="{data}">
					        <span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
					        <span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
							<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="已结算金额"
						name="record_money"
						width="100"
					>
						<template v-slot="row">
						    <span v-if="row.data.state == 2" style="color:green;">
								¥{{parseFloat(parseFloat(row.data.record_money).toFixed(2))}}
							</span>
							<span v-else>-</span>
						</template>
					</c-table-column> -->

					<c-table-column label="生成时间" name="create_date" width="140"></c-table-column>

					<!-- <c-table-column
						label="最近更新时间"
						name="update_date"
						width="140"
					></c-table-column> -->

					<!-- <c-table-column
						label="取消时间"
						name="cancel_date"
						width="140"
					>
						<template v-slot="{data}">
						    <span v-if="data.cancel_date && data.state==0" style="color:darkgray">{{data.cancel_date}}</span>
						    <span v-else>-</span>
						</template>
					</c-table-column>
					
					<c-table-column
						label="取消原因"
						name="reject_reason"
						width="140"
					>
						<template v-slot="{data}">
						    <span v-if="data.reject_reason && data.state==0" style="color:darkgray">{{data.reject_reason}}</span>
						    <span v-else>-</span>
						</template>
					</c-table-column> -->
				</c-table>

				<dt v-if="retailOrderList && retailOrderList.length > 0">关联零售订单</dt>
				<c-table v-if="retailOrderList && retailOrderList.length>0" :data="retailOrderList" :paging="false" border>
					<c-table-column label="订单号" width="150">
						<template v-slot="{data}">
							{{data.order_number}}
						</template>
					</c-table-column>

					<c-table-column label="归属商家" width="150">
						<template v-slot="{data}">
							{{data.stationed_name}}
						</template>
					</c-table-column>

					<c-table-column label="订单状态" width="100">
						<template v-slot="{data}">
							<span>{{orderStateName[data.order_state]}}</span>
						</template>
					</c-table-column>

					<c-table-column label="订单金额" width="100">
						<template v-slot="{data}">
							<span v-if="data.order_type==2 && data.payment_state == 1">
								{{data.product_money}}积分
							</span>
							<span v-if="data.order_type==2 && data.payment_state != 1">
								{{data.payment_money}}积分
							</span>
						</template>
					</c-table-column>

					<c-table-column label="服务数量" width="100">
						<template v-slot="{data}">
							×{{data.product_count}}
						</template>
					</c-table-column>
				</c-table>

				<dt v-if="reducedList && reducedList.length > 0">优惠信息</dt>
				<c-table v-if="reducedList && reducedList.length > 0" :data="reducedList" height="auto" :paging="false" border>
					<c-table-column label="优惠类型" width="100">
						<template v-slot="{data}">
							{{reducedTypeName[data.reduced_type]}}
						</template>
					</c-table-column>

					<c-table-column label="优惠金额" width="100">
						<template v-slot="{data}">
							<span v-if="data.reduced_money<=0" style="color:red">￥{{data.reduced_money}}</span>
							<span v-else style="color:green">￥ {{data.reduced_money}}</span>
						</template>
					</c-table-column>

					<c-table-column label="优惠承担方" width="110">
						<template v-slot="{data}">
							<span>{{carryTypeName[data.carry_type]}}</span>
						</template>
					</c-table-column>

					<c-table-column label="备注" width="300">
						<template v-slot="{data}">
							{{data.remark}}
						</template>
					</c-table-column>


					<c-table-column type="button" fixed="right" label="操作" width="100">
						<template v-slot="{data}">
							<c-table-button @click="reducedDetail(data.id,data.remark)">优惠明细</c-table-button>
						</template>
					</c-table-column>
				</c-table>

                <dt v-if="refundOrderList && refundOrderList.length>0">关联退款单</dt>
                <c-table v-if="refundOrderList && refundOrderList.length>0" :data="refundOrderList" height="auto" :paging="false" border>
                    <c-table-column label="状态" name="state" width="85">
                        <template v-slot="{data}">
                            <span style="color:#182eff" v-if="data.state==1">{{refundOrderStateName[data.state]}}</span>
                            <span style="color:darkgreen"
                                  v-if="data.state==2">{{refundOrderStateName[data.state]}}</span>
                            <span style="color:gray" v-if="data.state==3">{{refundOrderStateName[data.state]}}</span>
                            <span style="color:gray" v-if="data.state==4">{{refundOrderStateName[data.state]}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="退款单号" name="refund_number" width="130"></c-table-column>

                    <c-table-column label="服务退款" name="refund_total_money">
                        <template v-slot="{data}">
							<span style="color:blue"
                                  v-if="data.refund_total_money&&data.refund_total_money>0">￥{{data.refund_total_money.toFixed(2)}}</span>
                            <span v-else>--</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="申请时间" name="create_date" width="150"></c-table-column>

                    <c-table-column type="button" fixed="right" label="操作">
                        <template v-slot="{data}">
                            <c-table-button power="b_refund_info_detail"
                                            @click="navigateTo({path: `/after_sale_detail/refund/${data.refund_number}`, query: {refundType: data.refund_type}})">查看详情</c-table-button>
                        </template>
                    </c-table-column>
                </c-table>

				<div class="flex-between">
					<dl class="order-info flex-grow">
						<dt>交易信息</dt>
						<dd>
							<div class="order-info-item flex">
								<label>订单编号：</label>
								<div class="flex-center-cross">
									{{orderDetail.order_number }}
									<div class="tag" v-if="orderDetail.is_retail == 1" style="background:red">分销</div>
									<div class="tag" v-if="orderDetail.order_type!=1" style="background: #4686e0">
										{{orderTypeName[orderDetail.order_type] }}
									</div>

									<a @click="$copy(orderDetail.order_number)">复制单号</a>
								</div>
							</div>
							<div class="order-info-item flex">
								<label>运营模式：</label>
								<div>{{orderDetail.operation_mode==1?'平台自营':'商家自营'}}</div>
							</div>
							<div class="order-info-item flex">
								<label>所属商家：</label>
								<div>{{orderDetail.stationed_name}}</div>
							</div>
							<div class="order-info-item flex">
								<label>下单时间：</label>
								<div>{{orderDetail.create_date}} <!-- <a>更多</a> --></div>
							</div>
							<div class="order-info-item flex">
								<label>付款状态：</label>
								<div>{{paymentState}}</div>
							</div>
							<div class="order-info-item flex">
								<label>付款方式：</label>
								<div>{{orderDetail.payment_type?orderDetail.payment_type:'&#45;&#45;'}}</div>
							</div>
							<div class="order-info-item flex" v-if="orderDetail.payment_type=='现金'">
								<label>付款凭证：</label>
								<div>
									<c-image v-if="orderDetail.pay_voucher_url" :src="orderDetail.pay_voucher_url"
										size="60"></c-image>
									<span v-else>--</span>
								</div>
							</div>
						</dd>
					</dl>

					<dl class="order-info flex-grow">
						<dt>买家信息</dt>
						<dd>
							<div class="order-info-item flex" v-if="orderDetail.nick_name">
								<label>昵称：</label>
								<p>{{orderDetail.nick_name?orderDetail.nick_name:'--'}}</p>
							</div>
							<!-- <div class="order-info-item flex" v-if="orderDetail.user_login_name">
								<label>用户名：</label>
								<p>{{orderDetail.user_login_name}}</p>
							</div> -->
							<div class="order-info-item flex" v-if="orderDetail.user_manage_mobilephone">
								<label>手机号码：</label>
								<p>{{orderDetail.user_manage_mobilephone}}</p>
							</div>
							<div class="order-info-item flex" v-if="orderDetail.salesman_realname">
								<label>所属业务员：</label>
								<p>{{orderDetail.salesman_realname?orderDetail.salesman_realname:'--'}}</p>
							</div>
							<div class="order-info-item flex">
								<label>服务区域：</label>
								<p>{{orderDetail.receiving_address}}</p>
							</div>
							<div class="order-info-item flex">
								<label>买家留言：</label>
								<p>{{orderDetail.order_remark?orderDetail.order_remark:'--'}}</p>
							</div>
							<div class="order-info-item flex"
								v-if="orderDetail.order_type == 7 && cusTomInfo.custom_attach_url">
								<label>定制附件：</label>
								<p class="flex">
									<template v-if="cusTomInfo.custom_attach_url">
										<c-file v-for="(item, i) in cusTomInfo.custom_attach_url.split(',')" :key="i"
											:src="item" media style="width: 50px; height: 50px;"></c-file>
									</template>
								</p>
							</div>
							<div class="order-info-item flex"
								v-if="orderDetail.order_type == 7 && cusTomInfo.custom_remark">
								<label>定制备注：</label>
								<p>{{cusTomInfo.custom_remark?cusTomInfo.custom_remark:'--'}}</p>
							</div>
						</dd>
					</dl>
					
					<dl v-if="invoiceInfo" class="order-info flex-grow">
						<dt>发票开票信息</dt>
						<dd>
							<div v-if="invoiceInfo.invoice_type == 1" class="order-info-item flex">
								<label>发票类型：</label>
								<p>普通发票</p>
							</div>
							<div v-if="invoiceInfo.invoice_type == 2" class="order-info-item flex">
								<label>发票类型：</label>
								<p>增值税专用发票</p>
							</div>
							<div v-if="invoiceInfo.invoice_type == 3" class="order-info-item flex">
								<label>发票类型：</label>
								<p>增值税专用发票13%</p>
							</div>
							<div class="order-info-item flex">
								<label>纳税人识别号：</label>
								<p>{{invoiceInfo.tax_number}}</p>
							</div>
							<div class="order-info-item flex">
								<label>收票联系人：</label>
								<p>{{invoiceInfo.contact_name || '--'}}<span
										v-if="invoiceInfo.contact_phone">（电话：{{invoiceInfo.contact_phone}}）</span><span
										v-if="invoiceInfo.email">（邮箱：{{invoiceInfo.email}}）</span></p>
							</div>
							<div class="order-info-item flex">
								<label>收票地址：</label>
								<p>{{invoiceAddress || '--'}}</p>
							</div>
							<div class="order-info-item flex">
								<label>发票抬头：</label>
								<p>{{invoiceInfo.invoice_title}}</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1" class="order-info-item flex">
								<label>开户行账号：</label>
								<p>{{invoiceInfo.bank_account}}（开户行{{invoiceInfo.bank_name}}）</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1" class="order-info-item flex">
								<label>开票地址：</label>
								<p>{{invoiceInfo.kp_address || '--'}}</p>
							</div>
							<div v-if="invoiceInfo.invoice_type != 1" class="order-info-item flex">
								<label>开票电话：</label>
								<p>{{invoiceInfo.kp_phone || '--'}}</p>
							</div>
							<div class="order-info-item flex">
								<label>开票状态：</label>
								<p>{{orderDetail.invoice_state == 2 ? '已开票':'未开票'}}</p>
							</div>
							<div v-if="orderDetail.invoice_state == 2" class="order-info-item flex">
								<label>开票完成时间：</label>
								<p>{{orderDetail.invoice_date}}</p>
							</div>
							<div v-if="orderDetail.invoice_state == 2" class="order-info-item flex">
								<label>开票实收金额：</label>
								<p>{{parseFloat(orderDetail.reality_money).toFixed(2)}}</p>
							</div>
							<div v-if="orderDetail.invoice_state == 2" class="order-info-item flex">
								<label>开票凭证：</label>
								<p>
									<a :href="orderDetail.invoice_file" target="_blank">{{orderDetail.invoice_file}}</a>
								</p>
							</div>
						</dd>
					</dl>
				</div>
			</div>

			<template slot="button" v-if="type!='retail_order_detail'">
				<c-button
					v-if="auth('b_order_edit_price') && (orderDetail.order_state == 0||orderDetail.order_state == 1) && orderDetail.payment_state == 1 && orderDetail.order_type != 2"
					color="main" size="form" @click="orderEditPriceHandle()">调价</c-button>
				<c-button v-if="orderDetail.check_state == 2
				            && orderDetail.refunding_count==0
                            && (orderDetail.order_state != 5 && orderDetail.order_state != 6 && orderDetail.order_state != 12)
                            && orderDetail.operation_mode == 2" color="main" size="form"
					@click="changeOrderFlowStateHandle()">更新备注/服务进度</c-button>
				<c-button v-if="auth('b_order_close') && orderDetail.operation_mode == 2
                            && orderDetail.check_state == 2 && orderDetail.refunding_count==0 && orderDetail.returning_count==0
                            && (orderDetail.order_state == 1 || orderDetail.order_state == 2)" color="red" size="form"
					@click="closeHandle()">关闭订单</c-button>
				<c-button v-if="auth('b_order_close') && orderDetail.payment_state != 1
                && orderDetail.remain_refund_money > 0 && orderDetail.operation_mode == 2
                && orderDetail.check_state == 2 && orderDetail.refunding_count==0
                && orderDetail.returning_count==0 && orderDetail.order_state > 2 && orderDetail.order_state <= 4
                && orderDetail.remain_refund_money > 0 && orderDetail.refunding_count == 0" color="red" size="form"
					@click="closeHandle()">申请退款</c-button>
				<c-button
					v-if="auth('b_order_invoice_finish') && this.orderDetail.refunding_count == 0 && orderDetail.check_state == 2  && orderDetail.invoice_state == 1 && (orderDetail.order_state == 3 || orderDetail.order_state == 5) && invoiceInfo !=null "
					size="form" @click="onInvoiceFinish()">开票完成</c-button>
				<c-button
					v-if="auth('b_order_trandfer') && this.orderDetail.refunding_count == 0 && orderDetail.operation_mode == 2 && orderDetail.check_state == 2 && (orderDetail.order_state==2 || orderDetail.order_state==3) && orderDetail.wait_trandfer==1"
					size="form" @click="trandferOrder()">转单</c-button>
				<c-button
					v-if="auth('b_order_check') && orderDetail.operation_mode == 2 && orderDetail.order_state != 0 && orderDetail.order_state != 6 && orderDetail.check_state == 1 && userInfo.stationed_type == 2"
					size="form" @click="checkHandle('pass')">审核通过</c-button>
				<c-button
					v-if="auth('b_order_check') && orderDetail.operation_mode == 2 && orderDetail.order_state != 0 && orderDetail.order_state != 6 && orderDetail.check_state == 1 && userInfo.stationed_type == 2"
					size="form" color="red" @click="checkHandle('reject')">审核驳回</c-button>

			</template>
		</module>

		<!--订单调价 -->
		<c-dialog ref="orderEditPrice" title="订单调价" width="800" button-name="确定调价" @resolve="orderEditPriceHandle">
			<c-table ref="orderEditList" :data="editList" height="200" :paging="false">
				<c-table-column label="服务信息" width="300">
					<template #default="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url"
							:name="data.product_itemnumber + ' - '+data.product_name"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
					</template>
				</c-table-column>

				<!-- <c-table-column label="规格信息" name="product_sku_spec" width="120"></c-table-column> -->

				<!-- <c-table-column label="服务SKU编码" width="120">
					<template v-slot="{data}">
						{{data.product_sku_code?data.product_sku_code:'--'}}
					</template>
				</c-table-column> -->

				<c-table-column label="原单价" width="80">
					<template v-slot="{data}">
						<span v-if="orderDetail.order_state == 0 && !data.original_unit_money" style="color:brown;">
							待报价
						</span>
						<span v-else>
							￥{{parseFloat(data.original_unit_money).toFixed(2)}}
						</span>
					</template>
				</c-table-column>

				<!-- <c-table-column label="服务数量" width="80">
					<template v-slot="{data}">
						×{{data.product_count}}
					</template>
				</c-table-column> -->

				<!-- <c-table-column
					label="原价小计"
					width="100"
				>
					<template v-slot="{data}">
						￥{{data.product_money}}
					</template>
				</c-table-column> -->

				<c-table-column label="现单价" width="120">
					<template v-slot="{data}">
						<div class="flex-center-cross">
							￥<c-input v-model="data.product_unit_price" type="number" :limit="999999" decimal="2"
								style="width:80px"></c-input>
						</div>
					</template>
				</c-table-column>

				<!-- <c-table-column label="成交小计" width="100">
					<template v-slot="{data}">
						<span v-if="orderDetail.order_state == 0 || !data.original_unit_money" style="color:brown;">
							--
						</span>
						<span v-else>
							￥{{(data.product_count * (parseFloat(data.product_unit_price) || 0)).toFixed(2)}}
						</span>
					</template>
				</c-table-column> -->
			</c-table>
			<div class="order-price_total flex-between-center" style="padding:10px; background-color: #efefef;"
				v-if="orderDetail.operation_mode==2">
				<div>
					调价后应付总额：<span><b>￥{{(newProductMoney+(cusTomInfo.product_price_money||0)+parseFloat(new_logistics_money||0)).toFixed(2)}}</b></span>
				</div>
			</div>
		</c-dialog>

		<!--更新订单备注/服务进度（输入） -->
		<c-dialog ref="changeOrderFlow" title="更新订单备注/服务进度" width="700" @resolve="changeOrderFlowStateHandle">
			<div class="order-remark">
				<c-radio-group v-model="optionType" name="option_type" :disabled="orderDetail.refunding_count > 0 || orderDetail.operation_mode != 2 || orderDetail.check_state != 2 || orderDetail.order_flow_info.flow_state != 2">
					<c-radio value="1">仅更新备注/附件信息</c-radio>
					<c-radio value="2" :title="(orderDetail.refunding_count > 0 || orderDetail.operation_mode != 2 || orderDetail.check_state != 2 || orderDetail.order_flow_info.flow_state != 2)? '当前服务节点状态仅支持备注/上传附件操作':''">更新【{{orderDetail.order_flow_info.flow_name}}】的状态为【已完成】</c-radio>
				</c-radio-group>
				<textarea v-model="orderRemark" placeholder="请输入备注内容..."></textarea>
				<c-upload-file v-model="fileUrl" name="file_url" type="image,pdf" multiple></c-upload-file>
			</div>
		</c-dialog>

		<!--关闭订单弹框-->
		<c-dialog ref="closeDia" :title="this.orderDetail.order_state <= 2?'关闭订单':'订单申请退款'" width="600"
			@resolve="closeHandle">
			<div>
				<c-form ref="closeDiaForm">
					<c-form-item label="退款金额" v-if="this.orderDetail.order_state > 2" required
						:tip="'最多可退：￥'+this.orderDetail.remain_refund_money+'元'">
						<c-input name="refund_money" type="number" :limit="[0.01,orderDetail.remain_refund_money]"
							decimal="2"></c-input>
					</c-form-item>
					<c-form-item label="请输入取消原因" v-if="this.orderDetail.order_state <= 2" required>
						<c-input class="input-textarea" type="textarea" name="cancel_reason" rows="6"
							placeholder="请填入取消订单原因"></c-input>
					</c-form-item>
					<c-form-item label="退款原因" v-if="this.orderDetail.order_state > 2" required>
						<c-input class="input-textarea" type="textarea" name="cancel_reason" rows="6"
							placeholder="请填入退款原因"></c-input>
					</c-form-item>
				</c-form>
			</div>
		</c-dialog>

		<!--开票完成弹框-->
		<c-dialog ref="invoiceConf" title="开票确认" button-name="确认开票完成" width="500" height="360"
			@resolve="submitInvoiceFinish">
			<c-form>
				<div class="invoice">
					<p v-html="text_msg"></p>
					<!-- <c-datetime label="开票时间" v-model="invoiceDate" type="date"></c-datetime> -->
					<c-form-item label="开票时间">
						<c-datetime v-model="invoiceDate"></c-datetime>
					</c-form-item>
					<c-form-item label="实收金额">
						<c-input v-model="realityMoney" type="number" range="0,9999999" decimal="2"></c-input>
					</c-form-item>
					<c-form-item label="开票凭证">
						<c-radio-group v-model="invoice_file_type" name="invoice_file_type">
							<c-radio value="1">附件</c-radio>
							<c-radio value="2">链接</c-radio>
						</c-radio-group>
					</c-form-item>
					<c-form-item v-if="invoice_file_type == 1" label="附件">
						<c-upload-file v-model="invoice_file" name="invoice_file" type="image,pdf"></c-upload-file>
					</c-form-item>
					<c-form-item v-if="invoice_file_type == 2" label="链接" tip="http://或https://开头">
						<c-input v-model="invoice_file" name="invoice_file"></c-input>
					</c-form-item>
				</div>
			</c-form>
		</c-dialog>

		<!--订单转单弹窗 -->
		<c-dialog ref="orderTrandfer" :title="'订单【'+this.orderNumber+'】转单'" width="900" button-name="转单"
			@resolve="orderTrandferHandle">
			<c-table ref="orderTrandferList" :data="trandferList" height="320" :paging="false">
				<c-table-column type="selector"></c-table-column>

				<c-table-column label="服务信息" width="300">
					<template #default="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url"
							:name="data.product_itemnumber + ' - '+data.product_name"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
					</template>
				</c-table-column>

				<c-table-column label="规格信息" name="product_sku_spec"></c-table-column>

				<c-table-column label="待转单数量">
					<template v-slot="{data}">
						×{{data.product_quantity}}
					</template>
				</c-table-column>

				<c-table-column label="转单数量" width="150">
					<template v-slot="{data, selected}">
						<c-input v-model="trandferNum[data.product_sku]" type="number" width="100"
							:limit="[1, data.product_quantity]" :disabled="!selected" style="width:130px;" unit="件" />
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>

		<!--优惠明细-->
		<c-dialog ref="reducedDetailDialog" :title="reducedDetailTitle" width="900">
			<c-table ref="reducedDetailList" :data="reducedDetailList" height="350" :paging="false">
				<c-table-column label="服务信息" width="300">
					<template v-slot="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url"
							:name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"
							image-size="60"></product-info>
					</template>
				</c-table-column>

				<c-table-column label="规格信息" name="product_sku_spec" width="120"></c-table-column>

				<c-table-column label="服务数量" width="80">
					<template v-slot="{data}">
						×{{data.product_count}}
					</template>
				</c-table-column>

				<c-table-column label="优惠金额" width="100">
					<template v-slot="{data}">
						<span v-if="data.reduced_money<=0"
							style="color:red">￥{{(parseFloat(data.reduced_money) || 0).toFixed(2)}}</span>
						<span v-else style="color:green">￥{{(parseFloat(data.reduced_money) || 0).toFixed(2)}}</span>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		<!--审核驳回原因弹框 -->
		<c-dialog ref="rejectReason" title="不通过原因" width="550" button-name="审核驳回" @resolve="rejectHandle">
			<div class="order-remark">
				<textarea v-model="rejectReason" placeholder="请输入不通过原因..."></textarea>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import nodeList from '@/components/public/node_list.vue'
	import productInfo from '@/components/public/product_info.vue'

	export default {
		components: {
			nodeList,
			productInfo
		},

		props: {
			type: String,
			orderNumber: String
		},

		data() {
			return {
				orderDetail: '',
				productList: [],
				giftProductList: [],
				reducedList: [],
				cusTomList: [],
				cusTomInfo: '',
				invoiceInfo: '',
				invoiceDate: '',
				realityMoney: 0,
				editList: [],
				optionType: 1,
				orderRemark: '',
				fileUrl: '',
				remarkList: [],
				rejectReason: '',
				cancel_reason: '',
				order_remark: '',
				pack_info: [],
				new_logistics_money: 0,
				old_money: 0,
				invoice_file_type: '', //开票文件类型
				invoice_file: '', //发票文件
				text_msg: '',
				reducedTypeName: {
					0: '会员卡礼包',
					1: '优惠券',
					2: '限时折扣活动优惠',
					3: '会员等级折扣优惠',
					4: '砍价活动优惠',
					5: '抽奖奖品优惠',
					6: '积分抵扣',
					7: '秒杀活动优惠',
					8: '预售活动优惠',
					9: '拼团活动优惠',
					10: '特殊价格优惠',
					11: '新人活动',
					99: '订单调价'
				},
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				},
				retailOrderList: [],
				trandferList: [],
				trandferNum: {},
				refundOrderList: [],
				returnOrderList: [],
				refundOrderStateName: {
					1: '待审核',
					2: '审核通过',
					3: '已驳回',
					4: '已撤销'
				},
				refundTypeName: {
					1: '整单取消',
					2: '未发退款',
					3: '定金退款'
				},
				returnOrderStateName: {
					1: '待审核',
					2: '待用户退货',
					3: '待财务打款',
					5: '退款成功',
					6: '已驳回',
					8: '已撤销'
				},
				carryTypeName: {
					1: '平台承担',
					2: '商家承担',
					3: '平台/商家共同承担'
				},
				orderTypeName: {
					1: '普通',
					2: '积分',
					3: '升级赠品',
					4: '砍价',
					5: '预定(全款)',
					6: '预定(定金)',
					7: '定制',
					8: '拼团',
					9: '云仓提货',
					10: '送礼',
					11: '抽奖'
				},
				reducedDetailList: [],
				reducedDetailTitle: '优惠明细',
				orderFlowList: [],
				orderRewardList: [],
				orderHistoryList: [],
				userTypeName: {
					1: '平台会员',
					2: '爆款代理',
					3: '专业代理',
					4: '服务商',
					99: '平台'
				},
				transStateName: {
					0: '取消结算',
					1: '待结算',
					2: '已结算'
				},
				rewardTypeName: {
					201: '爆款代理费',
					202: '专业代理费',
					203: '市代代理费',
					204: '省代代理费',
					205: '业务员代理费',
					206: '平台服务费',
					207: '商家货款'
				},
			}
		},

		computed: {
			...mapState(['userInfo', 'systemConfig']),

			checkState() {
				var resultStr = '';
				if (this.orderDetail.payment_type == '现金') {
					resultStr = {
						1: this.orderDetail.order_state == 6 ? '' : '（待审核）',
						2: this.orderDetail.order_state == 6 || this.orderDetail.order_state == 1 ? '' : '（审核通过' + (
							this.orderDetail.push_state == 1 ? '' : '') + '）',
						3: '（审核驳回）',
					} [this.orderDetail.check_state];
				}
				return resultStr;
			},

			orderState() {
				var msg = "";
				if (this.orderDetail.refunding_count > 0) {
					msg = "订单申请退款";
				} else if (this.orderDetail.returning_count > 0) {
					msg = "订单申请【已发退货】";
				} else if (this.orderDetail.order_state == 0) {
					msg = "订单待报价";
				} else if (this.orderDetail.order_state == 12) {
                    msg = "订单服务终止";
                } else if (this.orderDetail.order_state != 0 && this.orderDetail.order_state != 6 && this.orderDetail
					.check_state == 1) {
					msg = "现金支付待审核";
				} else {
					msg = {
						1: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason + ')' :
							'等待买家付款',
						2: this.orderDetail.check_state == 3 ? '审核不通过(' + this.orderDetail.reject_reason + ')' :
							'买家已付款，等待商家开始服务',
						3: '商家服务进行中',
						4: '已服务完成，待客户验收',
						5: '客户已验收，交易成功',
						6: this.orderDetail.check_state == 3 ? '审核不通过' : '订单已取消'
					} [this.orderDetail.order_state];
				}
				return msg;
			},

			orderStateWord() {
				var msg = "";
				if (this.orderDetail.refunding_count > 0) {
					msg = "订单存在退款申请，请先处理完成后再进行其他操作";
				} else if (this.orderDetail.returning_count > 0) {
					msg = "订单存在【已发退货】申请，请先处理完成后再进行其他操作";
				} else if (this.orderDetail.order_state == 0) {
					msg = "当前服务价格面议，请对服务进行报价";
				} else if (this.orderDetail.order_state == 12) {
                    msg = "订单已完成退款，订单服务终止";
                } else if (this.orderDetail.order_state != 0 && this.orderDetail.order_state != 6 && this.orderDetail
					.check_state == 1) {
					msg = "买家已使用现金完成支付，请对支付结果进行审核";
				} else {
					msg = {
						1: this.orderDetail.payment_type == '现金' ? '当前订单使用现金方式支付，请及时审核' : '请在 ' + this.orderDetail
							.last_pay_date + ' 之前完成支付，否则订单将自动取消',
						2: '买家已付款，请尽快开始服务',
						3: '商家服务进行中，当前服务中的项目：【' + this.orderDetail.order_flow_info.flow_name + '】' + (this.orderDetail
							.order_flow_info.flow_state == 1 ? '，待客户完成该项目的支付后开始服务' : ''),
						4: '商家已完成全部服务，待客户验收',
						5: '客户于：' + this.orderDetail.confirm_date + '完成验收，订单交易成功',
						6: '取消原因：' + (this.orderDetail.cancel_reason_type_name ? this.orderDetail
							.cancel_reason_type_name : '') + (this.orderDetail.cancel_reason ? '（' + this
							.orderDetail.cancel_reason + '）' : '')
					} [this.orderDetail.order_state];
				}
				return msg;
			},

			paymentState() {
				return {
					1: '待付款',
					2: '待付尾款',
					3: '已付款'
				} [this.orderDetail.payment_state];
			},

			paymentTotal() {
				if (this.orderDetail.order_type == 7) {
					return this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money).toFixed(2) : (this
						.orderDetail.product_money + this.cusTomInfo.product_price_money + this.orderDetail
						.logistics_money + this.orderDetail.total_fee_money).toFixed(2);
				} else {
					if (this.orderDetail.payment_state == 2 || this.orderDetail.payment_state == 3) {
						return (this.orderDetail.payment_money || 0).toFixed(2);
					} else {
						return (this.orderDetail.product_money + this.orderDetail.logistics_money + this.orderDetail
							.total_fee_money).toFixed(2);
					}
				}
			},

			newProductMoney() {
				var total_product_money = 0;
				this.editList.forEach(item => {
					total_product_money += (parseFloat(item.product_unit_price) || 0) * item.product_count;

				});
				return total_product_money;
			},

			invoiceAddress() {
				if (!this.invoiceInfo) return '';
				return (this.invoiceInfo.address_province_name || '') + (this.invoiceInfo.address_city_name || '') + (this
					.invoiceInfo.address_county_name || '') + (this.invoiceInfo.address_details || '');
			},

			nodeList() {
				var resultNodeList = this.orderFlowList.map(item => {
					var obj = {};
					obj.name = item.name;
					obj.current = (item.state != 2);
					return obj;
				});
				return resultNodeList;
			}
		},

		watch: {
			orderNumber() {
				this.getOrderDetail();
			}
		},

		mounted() {
			this.getOrderDetail();
		},

		methods: {
			//获取订单详情数据
			getOrderDetail() {
				this.request({
					url: '/order/detail',
					data: {
						type: this.type,
						order_number: this.orderNumber
					},
					loading: true,
					success: data => {
						this.orderDetail = data.base_info;
						this.order_remark = this.orderDetail.order_remark;
						this.productList = data.product_sku_info;
						this.giftProductList = data.gift_product_list;
						this.reducedList = data.reduced_list;
						this.cusTomList = data.custom_list || [];
						this.cusTomInfo = data.custom_info || {};
						this.invoiceInfo = data.invoice_info;
						this.pack_info = data.pack_info;
						this.old_money = this.orderDetail.payment_state == 3 ? (this.orderDetail.payment_money)
							.toFixed(2) : (this.orderDetail.product_money + (this.cusTomInfo
									.product_price_money || 0) + this.orderDetail.logistics_money + this
								.orderDetail.total_fee_money).toFixed(2);
						this.retailOrderList = data.retail_order_list || [];
						this.refundOrderList = data.refund_order_list || [];
						this.returnOrderList = data.return_order_list || [];
						this.orderFlowList = data.order_flow_list || [];
						this.orderRewardList = data.order_reward_list || [];
						this.orderHistoryList = data.order_history_list || [];
					}
				});
			},
			//订单调价弹框输入等信息录入
			orderEditPriceHandle(stop) {
				if (!stop) {
					this.request({
						url: '/order/undelivered/product/list',
						data: {
							order_number: this.orderNumber
						},
						loading: true,
						success: data => {
							this.editList = (data.sku_list || []).map(item => {
								item.product_unit_price = '';
								return item;
							});
							this.new_logistics_money = this.orderDetail.logistics_money || '0.00';
							this.$refs.orderEditPrice.open();
						}
					});

				} else {
					stop();

					var flag = false;
					var new_total_money = 0;
					this.editList.forEach(item => {
						if (!item.product_unit_price) {
							this.$message({
								message: '请输入调价后单价'
							});
							flag = true;
							return;
						} else if (parseFloat(item.product_unit_price) <= 0) {
							this.$message({
								message: '调价后的单价不能小于等于0'
							});
							flag = true;
							return;
						} else {
							new_total_money += (parseFloat(item.product_unit_price) || 0) * item.product_count;
						}
					});

					if (!this.new_logistics_money) {
						this.$message({
							message: '请输入运费'
						});
						flag = true;
						return;
					} else if (parseFloat(this.new_logistics_money) < 0) {
						this.$message({
							message: '运费不能小于0'
						});
						flag = true;
						return;
					}

					if (flag) {
						return;
					}
					new_total_money = new_total_money + (this.cusTomInfo.product_price_money || 0) + parseFloat(this
						.new_logistics_money || 0);

					if (new_total_money <= 0) {
						this.$message({
							message: '调价后的应付总额不能为0元'
						});
					}

					this.$confirm({
						message: `确定要对当前订单执行调价操作吗？<br>(原应付金额:￥${this.old_money}，调价后应付金额:<span style="color: #f00">￥${parseFloat(new_total_money).toFixed(2)}</span>)`,
						resolve: () => {
							this.orderEditPriceVerifyHandle();
							this.$refs.orderEditPrice.close();
						}
					});
				}
			},
			//执行订单调价请求
			orderEditPriceVerifyHandle() {
				this.request({
					url: '/order/editPrice',
					data: Object.assign({
						order_number: this.orderNumber,
						logistics_money: this.new_logistics_money,
						product_skus: Array.from(this.editList, item => {
							return {
								product_sku: item.product_sku,
								product_unit_price: parseFloat(item.product_unit_price) || 0
							}
						})
					}),
					loading: true,
					success: () => {
						this.$refs.orderEditPrice.close();
						this.$message({
							message: '调价执行成功'
						});
						this.getOrderDetail();
					}
				});
			},
			//更新备注/附件、进度-响应方法
			changeOrderFlowStateHandle(stop) {
				if (!stop) {
					this.optionType = 1;
					this.orderRemark = '';
					this.fileUrl = '';
					this.$refs.changeOrderFlow.open();
				} else {
					stop();
					
					if (this.optionType==1 && !this.orderRemark.trim()) {
						this.$message({
							message: '请填写备注'
						});
						return;
					}

					this.request({
						url: this.optionType==1? '/order/add_history':'/order/change_flow_state',
						data: {
							order_number: this.orderNumber,
							remark: this.orderRemark.trim(),
							file_urls: this.fileUrl
						},
						loading: true,
						success: () => {
							this.$refs.changeOrderFlow.close();
							//刷新页面
							this.getOrderDetail();
							this.$message({
								type:'success',
								message: this.optionType == 1 ? '备注成功':'进度更新成功'
							});
						}
					});
				}
			},

			//关闭订单（弹窗）
			closeHandle(stop) {
				if (!stop) {
					this.$refs.closeDia.open();
				} else {
					stop();
					this.$refs.closeDiaForm.submit({
						url: '/order/cancel',
						rule: {
							refund_money: [{
								type: 'function',
								fun: (val, data) => {
									//指定商品且设置折扣时判断
									if (this.orderDetail.order_state > 2 && (!data.refund_money ||
											data.refund_money <= 0)) {
										return false;
									} else return true;
								},
								message: '请填写申请退款金额'
							}],
							refund_money2: [{
								type: 'function',
								fun: (val, data) => {
									//指定商品且设置折扣时判断
									if (parseFloat(data.refund_money) > parseFloat(this.orderDetail
											.remain_refund_money)) {
										return false;
									} else return true;
								},
								message: '该订单最多可退款：' + this.orderDetail.remain_refund_money + '元'
							}],
							cancel_reason: this.orderDetail.order_state > 2 ? '请填写申请退款原因信息' : '请填写关闭订单原因信息'
						},
						dataFormatter: data => {
							data.order_number = this.orderNumber;
							return data;
						},
						success: (data, res) => {
							this.$message({
								message: '操作成功！',
								type: 'success'
							});
							this.getOrderDetail();
							this.$refs.closeDia.close();
						}
					});

				}
			},

			//关闭订单（提交数据）
			closeSubmitForm() {
				this.request({
					url: '/order/cancel',
					data: {
						order_number: this.orderNumber,
						cancel_reason: this.cancel_reason.trim()
					},
					loading: true,
					success: () => {
						this.$message({
							message: '申请取消订单成功'
						});
						this.getOrderDetail();
					}
				});
			},
			//订单开票
			onInvoiceFinish() {
				this.order_ids = [this.orderDetail.id];
				this.invoiceDate = new Date().format('yyyy-MM-dd hh:mm:ss');
				this.realityMoney = (parseFloat(this.orderDetail.payment_money) || 0).toFixed(2);
				this.$refs.invoiceConf.open();
				this.text_msg =
					`确定要对订单【<font style="font-size:15px;color:red;">${this.orderDetail.order_number}</font>】执行开票完成操作吗？`;
			},
			submitInvoiceFinish(stop) {
				stop();
				if (!this.invoiceDate) {
					this.$message({
						message: '请选择开票时间'
					});
					return;
				}
				if (!this.realityMoney) {
					this.$message({
						message: '请输入实收金额'
					});
					return;
				}
				if (!this.invoice_file_type) {
					this.$message({
						message: '请选择开票凭证'
					});
					return;
				}
				if (!this.invoice_file) {
					if (this.invoice_file_type == 1) {
						this.$message({
							message: '请上传附件'
						});
						return;
					}
					if (this.invoice_file_type == 2) {
						this.$message({
							message: '请输入链接'
						});
						return;
					}
				} else if (this.invoice_file_type == 2) {
					if (this.invoice_file.indexOf('http://') !== 0 && this.invoice_file.indexOf('https://') !== 0) {
						this.$message({
							message: '请输入以http://或https://开头的完整链接'
						});
						return;
					}
				}
				this.request({
					url: '/order/invoice_finish',
					data: {
						order_ids: this.order_ids,
						invoice_date: this.invoiceDate,
						reality_money: this.realityMoney,
						is_bath: 0,
						invoice_file_type: this.invoice_file_type,
						invoice_file: this.invoice_file
					},
					loading: true,
					success: data => {
						this.$message({
							type: 'success',
							message: '执行开票完成操作成功'
						});
						this.getOrderDetail();
						this.$refs.invoiceConf.close();
					}
				});
			},
			//发开转单弹窗
			trandferOrder() {
				this.orderNumber = this.orderDetail.order_number;
				if (this.orderDetail.order_type == 7) { //定制订单
					this.$confirm({
						message: '是否确定对【定制】订单【' + this.orderNumber + '】进行转单？',
						resolve: () => {
							this.request({
								url: '/order/trandfer',
								data: {
									trandfer_type: 3,
									/**3=整单转单  2=部分转单*/
									order_number: this.orderNumber
								},
								loading: true,
								success: data => {
									this.$refs.orderTrandfer.close();
									this.$message({
										message: '转单任务已提交，请在【代发订单】功能中查看转单后的代发订单'
									});
									//刷新页面
									this.$refs.search.search();
								}
							});
						}
					});
				} else { //非定制
					this.request({
						url: '/order/untrandfer/product/list',
						data: {
							order_number: this.orderDetail.order_number
						},
						loading: true,
						success: data => {
							this.trandferList = data;
							this.$refs.orderTrandfer.open();
							//赋值默认转单数量
							this.trandferList.forEach(item => {
								this.trandferNum[item.product_sku] = item.product_quantity;
							});

						}
					});
				}
			},
			//订单转单
			orderTrandferHandle(stop) {
				var flag = true;
				stop();
				let list = this.$refs.orderTrandferList.getRow('selected');
				if (!list.length) {
					this.$message({
						message: '请选择要转单的服务'
					});
					flag = false;
					return;
				}
				list.forEach(item => {
					if ((parseInt(this.trandferNum[item.data.product_sku]) || 0) <= 0) {
						this.$message({
							message: '请选择要转单的服务'
						});
						flag = false;
						return;
					}
					if ((parseInt(this.trandferNum[item.data.product_sku]) || 0) > parseInt(item.data
							.product_quantity)) {
						this.$message({
							message: '转单数量不能超过剩余可转数量'
						});
						flag = false;
						return;
					}
				});
				if (flag) {
					this.request({
						url: '/order/trandfer',
						data: {
							order_number: this.orderNumber,
							order_sku_list: Array.from(list, item => {
								return {
									product_sku: item.data.product_sku,
									count: parseInt(this.trandferNum[item.data.product_sku])
								}
							})
						},
						loading: true,
						success: data => {
							this.$refs.orderTrandfer.close();
							this.$message({
								message: '转单任务已提交，请在【代发订单】功能中查看转单后的代发订单'
							});
							//刷新页面
							this.getOrderDetail();
						}
					});
				}
			},
			//展示优惠明细数据
			reducedDetail(reduced_id, title) {
				this.request({
					url: '/order/reduced/detail',
					data: {
						order_number: this.orderDetail.order_number,
						reduced_id: reduced_id
					},
					loading: true,
					success: data => {
						this.reducedDetailList = data;
						this.reducedDetailTitle = (title || '') + '-优惠明细';
						this.$refs.reducedDetailDialog.open();
					}
				});
			},
			//审核订单
			checkHandle(type, confirm) {
				var order_number_list = [];
				order_number_list.push(this.orderNumber);
				if (type == 'pass') {
					this.$confirm({
						message: '确定要审核通过该订单吗？',
						resolve: () => {
							this.request({
								url: '/order/check',
								data: {
									order_number_list: order_number_list,
									check_state: 2,
									push_u8: 2
								},
								loading: true,
								success: () => {
									this.$message({
										message: '订单审核成功'
									});
									this.getOrderDetail();
									this.$bus.$emit('order.update', {});
								}
							});
						}
					});
				} else if (confirm) {
					this.request({
						url: '/order/check',
						data: {
							order_number_list: order_number_list,
							check_state: 3,
							push_u8: 0,
							reject_reason: this.rejectReason.trim()
						},
						loading: true,
						success: () => {
							this.$message({
								message: '订单审核驳回执行成功'
							});
							this.getOrderDetail();
							this.$bus.$emit('order.update', {});
						}
					});
				} else {
					this.rejectHandle();
				}
			},
			//审核（提交数据）
			rejectHandle(stop) {
				if (!stop) {
					this.rejectReason = '';
					this.$refs.rejectReason.open();
				} else {
					stop();

					if (!this.rejectReason.trim()) {
						this.$message({
							message: '请填写审核驳回原因'
						});
						return;
					}

					this.checkHandle('reject', true);
					this.$refs.rejectReason.close();
					this.$bus.$emit('order.update', {});
				}
			},
			/**
			 * 安全解析 material_file 为JSON数组（模板中调用）
			 */
			parseMaterialFile(rawData) {
				if (!rawData) return [];

				// 转为字符串并去除首尾空格
				const jsonStr = String(rawData).trim();
				if (jsonStr === '') return [];

				// 尝试解析JSON，失败返回空数组
				try {
					const jsonObj = JSON.parse(jsonStr);
					// 确保返回数组（单个对象转为数组）
					return Array.isArray(jsonObj) ? jsonObj : [jsonObj];
				} catch (error) {
					console.error('JSON解析失败：', error.message);
					return []; // 解析失败时显示空列表，避免组件崩溃
				}
			},
			/**
			 * 格式化文件类型（处理null/非字符串）
			 */
			getFormatFileType(fileType) {
				if (!fileType) return "UNKNOWN";
				const typeStr = String(fileType);
				return typeStr.toUpperCase();
			},

			/**
			 * 根据文件类型获取图标类名
			 */
			getFileIconClass(fileType) {
				const type = this.getFormatFileType(fileType).toLowerCase();
				switch (type) {
					case 'jpg':
					case 'jpeg':
					case 'png':
					case 'gif':
						return 'fa-solid fa-image text-blue-500';
					case 'wps':
					case 'doc':
					case 'docx':
						return 'fa-solid fa-file-word text-green-500';
					case 'apk':
						return 'fa-solid fa-mobile-screen-button text-orange-500';
					default:
						return 'fa-solid fa-file text-gray-500';
				}
			},

			/**
			 * 格式化文件大小（处理null/无效格式）
			 */
			formatFileSize(sizeStr) {
				if (!sizeStr) return "0KB";

				const match = sizeStr.match(/^(\d+(\.\d+)?)([KMG]?B)$/i);
				if (!match) return sizeStr;

				const size = parseFloat(match[1]);
				const unit = match[3].toUpperCase();
				const units = {
					B: 1,
					KB: 1024,
					MB: 1024 * 1024,
					GB: 1024 * 1024 * 1024
				};
				const bytes = size * units[unit];

				if (bytes >= units.GB) return (bytes / units.GB).toFixed(1) + 'GB';
				if (bytes >= units.MB) return (bytes / units.MB).toFixed(1) + 'MB';
				if (bytes >= units.KB) return (bytes / units.KB).toFixed(1) + 'KB';
				return bytes + 'B';
			},

			/**
			 * 判断是否为图片文件（安全处理类型）
			 */
			isImageFile(fileType) {
				const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
				return imageTypes.includes(this.getFormatFileType(fileType).toLowerCase());
			},

			/**
			 * 下载文件（兼容file_url为null）
			 */
			downloadFile(file) {
				if (!file.file_url) {
					alert('文件下载地址无效');
					return;
				}
				const link = document.createElement('a');
				link.href = file.file_url;
				link.download = file.file_name || '未知文件';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},

			/**
			 * 预览文件（兼容file_url为null）
			 */
			previewFile(file) {
				if (!file.file_url) {
					alert('文件预览地址无效');
					return;
				}

				if (/(png|jpg|jpe?g|gif)$/i.test(file.file_url.substring(file.file_url.lastIndexOf('.') + 1))) {
					this.$preview({
						src: file.file_url
					})
				} else {
					window.open(file.file_url);
				}
			}

		}
	}
</script>

<style lang="stylus" scoped>
	.order {
		&-state {
			height: 120px;
			padding: 0 34px;
			font-size: 13px;
			color: #fff;
			background: #005CD9;
			background-image: url('~@/assets/image/order_detail_state_bg.png');
			background-size: 100% auto;
			background-position: left bottom;
			background-repeat: no-repeat;

			h1 {
				font-size: 24px;
			}
		}

		&-node {
			padding: 40px 0 60px;
			margin: 14px 30px 0;
			overflow: auto;
			background: #F6FAFF;

			>>> .m-node-list {
				float: left;
				box-sizing: border-box;
				min-width: 100%;
				padding: 0 40px;

				li {
					&.z-now {
						p {
							color: #00BE50;
						}
				
						~ li {
							p {
								color: #666;
							}
						}
					}

					p {
						color: #00BE50;
					}
				}
			}
		}

		&-info {
			&:nth-child(n+2) {
				margin-left: 30px;
			}

			dd {
				padding: 12px 26px;
				background: #FAFAFA;
			}

			&-item {
				padding: 9px 0;
				line-height: 20px;
				font-size: 13px;

				label {
					min-width: 5em;
					color: #666;
					text-align: right;
				}

				>div {
					.tag {
						border-radius: 2px;
						padding: 0 5px;
						margin-left: 6px;
						line-height: 18px;
						color: #fff;
					}

					a {
						margin-left: 6px;
						color: #005CD9;
					}
				}
			}
		}

		&-detail {
			padding: 14px 30px 40px;

			dt {
				border-left: 3px solid #000;
				padding-left: 5px;
				margin-top: 25px;
				margin-bottom: 20px;
				line-height: 18px;
				font-size: 16px;
				font-weight: bold;
			}
		}

		&-total {
			height: 45px;
			padding: 0 16px;
			font-size: 13px;
			color: #000;
			background: #FAFAFA;

			span {
				color: var(--color-main);
			}

			b {
				font-size: 16px;
			}
		}

		&-remark {
			padding: 20px;

			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}

	.logistics {
		&-order {
			padding: 14px 18px;

			li {
				border: 1px solid #ddd;
				padding: 0 26px;
				line-height: 42px;
				font-size: 14px;
				color: #666;
				cursor: pointer;

				&:nth-child(n+2) {
					margin-left: 20px;
				}

				&:hover {
					background: #F0F3FC;
				}

				&.z-crt {
					border-color: #005CD9;
					color: #005CD9;
					background: #F0F3FC;
				}
			}
		}

		&-list {
			height: 434px;
			padding: 20px;
			overflow: auto;
			background: #FAFAFA;

			li {
				padding: 10px 0;
				line-height: 24px;
				font-size: 13px;
				color: #333;

				label {
					margin-right: 16px;
					color: #666;
				}
			}
		}
	}

	.invoice-info {
		max-width: 1000px;
		padding: 30px 0;

		dt {
			border-left: 3px solid #000;
			padding-left: 5px;
			margin-bottom: 26px;
			line-height: 18px;
			font-size: 16px;
			font-weight: bold;
		}

		dd>div:nth-child(1) {
			margin-right 50px;
		}

		&-item {
			padding: 9px 0;
			line-height: 20px;
			font-size: 13px;

			label {
				min-width: 7em;
				color: #666;
				text-align: right;
			}

			p {
				a {
					color: #005CD9;
				}
			}
		}
	}

	.invoice {
		font-size: 14px;
		color: #000;

		p {
			color: #666;
			height: 30px;
		}
	}

	.input-textarea {
		box-sizing: border-box;
		width: 100%;
		height: 150px;
		border: 1px solid #ddd;
		padding: 10px 14px;
		line-height: 20px;
		resize: none;
	}
	
	.file-list-container {
	  padding: 20px;
	  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
	}
	
	.file-list-title {
	  margin: 0 0 20px 0;
	  font-size: 18px;
	  color: #333;
	  border-bottom: 1px solid #eee;
	  padding-bottom: 10px;
	}
	
	.file-card-list {
	  display: grid;
	  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	  gap: 5px;
	}
	
	.file-card {
	  display: flex;
	  align-items: center;
	  padding: 5px 12px;
	  border: 1px solid #eee;
	  border-radius: 8px;
	  transition: all 0.3s ease;
	  background-color: #fff;
	}
	
	.file-card:hover {
	  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	  border-color: #e0e0e0;
	}
	
	.file-icon {
	  margin-right: 12px;
	  font-size: 24px;
	}
	
	.file-info {
	  flex: 1;
	  min-width: 0;
	}
	
	.file-name {
	  font-size: 14px;
	  color: #333;
	  white-space: nowrap;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  margin-bottom: 4px;
	}
	
	.file-meta {
	  display: flex;
	  align-items: center;
	  font-size: 12px;
	  color: #666;
	  gap: 8px;
	}
	
	.file-type-tag {
	  padding: 2px 6px;
	  border-radius: 4px;
	  background-color: #f5f5f5;
	  color: #888;
	}
	
	.file-actions {
	  display: flex;
	  gap: 8px;
	}
	
	.btn-download, .btn-preview {
	  padding: 4px 8px;
	  border: none;
	  border-radius: 4px;
	  font-size: 12px;
	  cursor: pointer;
	  display: flex;
	  align-items: center;
	  gap: 4px;
	}
	
	.btn-download {
	  background-color: #4299e1;
	  color: white;
	}
	
	.btn-download:hover {
	  background-color: #3182ce;
	}
	
	.btn-preview {
	  background-color: #f5f5f5;
	  color: #333;
	}
	
	.btn-preview:disabled {
	  background-color: #fafafa;
	  color: #ccc;
	  cursor: not-allowed;
	}
	
	.btn-preview:not(:disabled):hover {
	  background-color: #eee;
	}
	
	@import url('https://cdn.bootcdn.net/ajax/libs/font-awesome/6.4.0/css/all.min.css');
	
	.no-file-tip {
	  padding: 20px;
	  color: #666;
	  text-align: center;
	  background-color: #f9f9f9;
	  border-radius: 8px;
	  margin: 10px 0;
	}

	.service-record {
		max-height: 400px;
		overflow: auto;
		background: #FAFAFA;

		ul {
			position: relative;
			padding: 20px 50px;

			&:before {
				content: '';
				position: absolute;
				left: 32px;
				top: 20px;
				bottom: 0;
				width: 1px;
				background: #eee;
			}

			li {
				position: relative;

				&:nth-child(n+2) {
					margin-top: 12px;
				}

				&:before {
					content: '';
					position: absolute;
					left: -23px;
					top: 3px;
					box-sizing: border-box;
					width: 12px;
					height: 12px;
					border: 2px solid #ddd;
					border-radius: 100%;
					background: #fff;

					^[-1]:nth-child(1)^[-1..-1] {
						border-color: #0060EF;
					}
				}

				&:nth-child(1) {
					.service {
						&-date {
							font-size: 13px;
							font-weight: bold;
							color: #0060EF;
						}
					}
				}

				.service {
					&-date {
						line-height: 20px;
						font-size: 12px;
						color: #999;
					}

					&-remark {
						margin-top: 6px;
						line-height: 22px;
						font-size: 13px;
					}

					&-file {
						padding: 0 14px;
						margin-top: 6px;
						background: #F5F5F5;

						&-item {
							gap: 10px;
							height: 46px;
							font-size: 12px;
							color: #666;
							cursor: pointer;

							&:hover {
								color: #0060EF
							}

							i {
								font-size: 24px;
							}

							p {
								max-width: 300px;
							}
						}
					}
				}
			}
		}
	}
</style>